// extracted by mini-css-extract-plugin
export var layoutContainer = "_4i-0";
export var layoutContainerOpen = "_4i-5";
export var layoutContainerResizing = "_4i-1";
export var mainContent = "_4i-2";
export var resizeDivider = "_4i-3";
export var slidePanel = "_4i-4";